import { reportBNSF } from './columns';
import { createTableCell } from '../../utils';
import { Urls } from '../../urls';

/**
 * Construct report.
 * @param {Object} data
 * @param {string} selector
 */
function constructReport(data, selector) {

  $(selector).text('');

  const parent = document.querySelector(selector);
  const table = document.createElement('table');

  table.style.fontSize = '0.86rem';

  reportBNSF.forEach(col => {
    const el = document.createElement('tr');

    const titleEl = createTableCell(col.title);
    const valueEl = createTableCell(data[col.field] || '-');

    titleEl.style.fontWeight = 'bold';

    el.appendChild(titleEl);
    el.appendChild(valueEl);

    table.appendChild(el);
  });

  parent.appendChild(table);
}

/**
 * Get data from BNSF and display table.
 *
 * @param {object} row - Record corresponding to the clicked row.
 */
export function getShipmentReportBNSF(row) {
  const closeReport = $('#closeShipmentReport');
  const header = $('#headerBNSF');
  const spinner = $('#bnsfReportSpinner');

  $.ajax({
    method: 'GET',
    url: Urls['bnsf-get-shipment-report'](row.id),
    dataType: 'json',

    success(data) {
      header.addClass('d-flex');
      spinner.attr('hidden', true);
      closeReport.prop('disabled', false);

      constructReport(data[0], '#tableBNSF');
    },
    error(jqXHR, textStatus, errorThrown) {
      header.addClass('d-flex');
      spinner.attr('hidden', true);
      closeReport.prop('disabled', false);

      if (jqXHR.status === 404) {
        $('#infoBnsfText').text('Not found');
      } else {
        $('#infoBnsfText').text('Error in API request');
      }
    },
  });
}
